import { documentStatus } from "../../constants/statusConstants";
import { getDDMMYYYFormat } from "../../helper/dateTimeHelper";
import { logoBase64 } from "../procedure/info-technology-process/repair-tools/base64";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const getTitleForDocument = (document: any) => {
  if (document?.isFolder) return !document?.Title ? "Gốc" : document?.Title;
  return !document?.Title ? document?.nameWithoutExt : document?.Title;
};

const isDocumentPublic = (docStatusId: any) => {
  return docStatusId === documentStatus.interimpublish.id || docStatusId === documentStatus.publish.id;
};

const getTitleForEffectiveBaseOnStatus = (docStatusId: any) => {
  return isDocumentPublic(docStatusId) ? "Hiệu lực:" : "Thời gian hiệu lực:";
};

//phan nay cua truong
//thay doi onChange text ben tinh trang
const getLabelStatus = (data: any) => {
  switch (data) {
    case documentStatus.new.id:
      return "Người khởi tạo";
    case documentStatus.compose.id:
      return "Người soạn thảo";
    case documentStatus.feedback.id:
      return "Người lấy ý kiến";
    case documentStatus.review.id:
      return "Người soát xét";
    case documentStatus.check.id:
      return "Người kiểm tra";
    case documentStatus.interimpublish.id:
    case documentStatus.publish.id:
      return "Người ban hành";
    case documentStatus.approval.id:
    case documentStatus.readytopublish.id:
      return "Người duyệt";
    default:
      return "Người thực hiện";
  }
};
//end

const getRangeDateText = (dateFrom: any, dateTo: any) => {
  let dateFromText = "";
  let dateToText = "";
  if (dateFrom) dateFromText = getDDMMYYYFormat(dateFrom);

  if (dateTo) dateToText = getDDMMYYYFormat(dateTo);

  if (dateFrom || dateTo) return `${dateFromText} - ${dateToText}`;
  return "";
};

const replaceHTMLtoTitle = (str: string) => {
  if (str) {
    var doc = new DOMParser().parseFromString(str, "text/html");
    return doc.firstChild?.textContent;
  } else return "";
};

const convertToRoman = (num: number) => {
  const romanNumerals = [
    { value: 1000, symbol: "M" },
    { value: 900, symbol: "CM" },
    { value: 500, symbol: "D" },
    { value: 400, symbol: "CD" },
    { value: 100, symbol: "C" },
    { value: 90, symbol: "XC" },
    { value: 50, symbol: "L" },
    { value: 40, symbol: "XL" },
    { value: 10, symbol: "X" },
    { value: 9, symbol: "IX" },
    { value: 5, symbol: "V" },
    { value: 4, symbol: "IV" },
    { value: 1, symbol: "I" },
  ];

  let result = "";

  romanNumerals.forEach((numeral) => {
    while (num >= numeral.value) {
      result += numeral.symbol;
      num -= numeral.value;
    }
  });

  return result;
};

const makeTree = (nodes: any[], CustomParentId: any): any => {
  return nodes
    .filter((node: any) => node.CustomParentId === CustomParentId)
    .reduce(
      (tree, node) => [
        ...tree,
        {
          ...node,
          children: makeTree(nodes, node.CustomId),
        },
      ],
      [],
    );
};

const flattenTree = (nodes: any[], CustomParentId: any, result: any[] = []): any => {
  nodes
    .filter((node: any) => node.CustomParentId === CustomParentId)
    .forEach((node: any) => {
      result.push(node);
      flattenTree(nodes, node.CustomId, result);
    });
  return result;
};

// const imageUrlToBase64 = async (imageUrl: string): Promise<string> => {
//   try {
//     const response = await fetch(imageUrl);

//     if (!response.ok) {
//       throw new Error(`Failed to fetch image: ${response.status} ${response.statusText}`);
//     }

//     const blob = await response.blob();

//     return new Promise<string>((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(blob);
//       reader.onloadend = () => {
//         const base64String = reader.result?.toString().split(',')[1];
//         if (base64String) {
//           resolve(base64String);
//         } else {
//           reject(new Error('Failed to convert image to Base64'));
//         }
//       };
//       reader.onerror = (error) => {
//         reject(error);
//       };
//     });
//   } catch (error) {
//     throw error;
//   }
// };

const isGUID = (input: string): boolean => {
  const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return guidPattern.test(input);
};

const createFileContentForEditor = async (data: any, fileName: any = undefined) => {
  let cleanedData = data.replace(/<!DOCTYPE\s+html>/i, "");
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(cleanedData, "text/html");
  const imageTags = htmlDoc.getElementsByTagName("img");
  const styleTags = htmlDoc.getElementsByTagName("style");
  const imageContents: string[] = [];
  const styleContents: string[] = [];
  for (let i = 0; i < imageTags.length; i++) {
    const imageSrc = imageTags[i].getAttribute("src");
    if (imageSrc) {
      // if (i > 0) {
      //   try {
      //     const base64String = await imageUrlToBase64(imageSrc);
      //     cleanedData = cleanedData.replaceAll('&#58;', ':');
      //     cleanedData = cleanedData.replace(_.escape(imageSrc), "data:image/jpg;base64," + base64String);
      //   } catch (error) {
      //     console.error('Error:', error);
      //   }
      // }
      imageContents.push(imageSrc);
    }
  }

  for (let i = 0; i < styleTags.length; i++) {
    const styleContent = styleTags[i].innerHTML;
    if (styleContent) {
      styleContents.push(styleContent);
    }
  }
  var jsonContent = cleanedData;
  var enc = new TextEncoder(); // always utf-8
  const buffer = enc.encode(jsonContent);
  const concatenatedContents = imageContents.join("\n") + "\n" + styleContents.join("\n");
  return {
    size: buffer.length,
    content: buffer,
    name: fileName,
    images: imageContents,
    styles: styleContents,
    concatenatedContents: concatenatedContents,
  };
};

const decodeHTMLEntities = (str: any) => {
  const element = document.createElement("p");
  if (str && typeof str === "string") {
    // strip script/html tags
    str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
    str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
    element.innerHTML = str;
    str = element.textContent;
    element.textContent = "";
  }

  return str;
};

const htmlType = (data: any) => {
  return `
  <table style="border-collapse: collapse;" cellspacing="0" height="40px">
              <tr>
                  <td
                      style="
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                      rowspan="2"
                  >
                      <p style="text-indent: 0pt; text-align: left;"><br /></p>
                      <p style="text-indent: 0pt; text-align: left; "><bfr /></p>
                      <p style="padding-left: 14pt; text-indent: 0pt; text-align: left;">
                          <span>
                              <table border="0" cellspacing="0" cellpadding="2" height="40px">
                                  <tr>
                                      <td >
                                          <img
                                              style="padding-bottom: 40px"
                                              width="100"
                                              height="30"
                                              src=${logoBase64}
                                          />
                                      </td>
                                  </tr>
                              </table>
                          </span>
                      </p>
                  </td>
                  <td
                      style="
                          width: 197pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                          padding-bottom: 25px;
                      "
                      rowspan="2"
                  >
                      <p class="s1" style="padding-left: 5pt; text-indent: 0pt; text-align: left; margin-bottom: 0; font-style: italic; font-weight: 500">Biểu mẫu</p>
                      <p style="text-indent: 0pt; text-align: left;margin-bottom: 0; display:none"><br /></p>
                      <p class="s1" style="text-align: center; padding: 0px 10px;">QUY ĐỊNH VỀ HÌNH THỨC TRÌNH BÀY TÀI LIỆU</p>
                  </td>
                  <td
                      style="
                          width: 113pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Mã số: V.QMS-A02</p>
                  </td>
              </tr>
              <tr style="height: 48pt;">
                  <td
                      style="
                          width: 113pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;margin-bottom: 0">Ban hành: 01</p>
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;margin-bottom: 0">Hiệu lực: 10/07/2022 </p>
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;margin-bottom: 0">Trang: 
                        <span style="font-weight: 600">
                          1/1
                        </span>
                      </p>
                  </td>
              </tr>
          </table>
        <div
          class="content"
          style="pointer-events: none; background-position: center; z-index: -1; top: 0; opacity: 1;"
        >
          ${data
            .sort((a: any, b: any) => a.Position - b.Position)
            .map((e: any) => `<div style="padding-top: -10pt; color: "red">${e.Content}</div>`)
            .join("")}
        </div>`;
};

const generateGUID = (): string => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

const removeVietnameseTones = (str: string): string => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase();
};

const truncateText = (text: string | undefined, maxLength: number): string => {
  if (!text || typeof text !== "string") {
    return "";
  }
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + "...";
};

const getDeviceId = async () => {
  let deviceId = localStorage.getItem("deviceId");

  if (!deviceId) {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    deviceId = result.visitorId;
    localStorage.setItem("deviceId", deviceId);
  }

  return deviceId;
};

const getFileNameFromUrl = (url: string | undefined) => {
  if (typeof url !== "string") return "";
  const parts = url.split("/");
  return parts[parts.length - 1];
};

const findUrlsInText = (text: string | undefined) => {
  if (!text) return [];
  const urlRegex = /(https?:\/\/[^\s/$.?#].[^\s]*)/gi;
  const urls = text.match(urlRegex);
  return urls || [];
};

export {
  getTitleForDocument,
  getTitleForEffectiveBaseOnStatus,
  getRangeDateText,
  isDocumentPublic,
  getLabelStatus,
  createFileContentForEditor,
  replaceHTMLtoTitle,
  convertToRoman,
  makeTree,
  flattenTree,
  isGUID,
  htmlType,
  decodeHTMLEntities,
  generateGUID,
  removeVietnameseTones,
  truncateText,
  getDeviceId,
  getFileNameFromUrl,
  findUrlsInText,
};
